'use strict';

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularCookies = require('angular-cookies');

var _angularCookies2 = _interopRequireDefault(_angularCookies);

var _angularResource = require('angular-resource');

var _angularResource2 = _interopRequireDefault(_angularResource);

var _angularSanitize = require('angular-sanitize');

var _angularSanitize2 = _interopRequireDefault(_angularSanitize);

var _ngFileUpload = require('ng-file-upload');

var _ngFileUpload2 = _interopRequireDefault(_ngFileUpload);

var _angularUiMask = require('angular-ui-mask');

var _angularUiMask2 = _interopRequireDefault(_angularUiMask);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _angularUiBootstrap = require('angular-ui-bootstrap');

var _angularUiBootstrap2 = _interopRequireDefault(_angularUiBootstrap);

require('ui-select');

require('angular-slugify');

require('ng-toast');

require('marked');

require('angular-marked');

var _app = require('./app.config');

var _auth = require('../components/auth/auth.module');

var _auth2 = _interopRequireDefault(_auth);

var _account = require('./account');

var _account2 = _interopRequireDefault(_account);

var _admin = require('./admin');

var _admin2 = _interopRequireDefault(_admin);

var _navbar = require('../components/navbar/navbar.component');

var _navbar2 = _interopRequireDefault(_navbar);

var _footer = require('../components/footer/footer.component');

var _footer2 = _interopRequireDefault(_footer);

var _datePicker = require('../components/datePicker/datePicker.component');

var _datePicker2 = _interopRequireDefault(_datePicker);

var _scheduleView = require('../components/scheduleView/scheduleView.component');

var _scheduleView2 = _interopRequireDefault(_scheduleView);

var _main = require('./main/main.component');

var _main2 = _interopRequireDefault(_main);

var _schedule = require('./schedule/schedule.component');

var _schedule2 = _interopRequireDefault(_schedule);

var _event = require('./events/event.component');

var _event2 = _interopRequireDefault(_event);

var _directory = require('./directory/directory.component');

var _directory2 = _interopRequireDefault(_directory);

var _freightTime = require('./freightTime/freightTime.component');

var _freightTime2 = _interopRequireDefault(_freightTime);

var _update = require('./update/update.component');

var _update2 = _interopRequireDefault(_update);

var _media = require('./media/media.component');

var _media2 = _interopRequireDefault(_media);

var _app2 = require('./app.constants');

var _app3 = _interopRequireDefault(_app2);

var _util = require('../components/util/util.module');

var _util2 = _interopRequireDefault(_util);

require('../components/services');

var _hasDay = require('../filters/hasDay/hasDay.filter');

var _hasDay2 = _interopRequireDefault(_hasDay);

var _beachShort = require('../filters/beachShort/beachShort.filter');

var _beachShort2 = _interopRequireDefault(_beachShort);

var _dayOfWeek = require('../filters/dayOfWeek/dayOfWeek.filter');

var _dayOfWeek2 = _interopRequireDefault(_dayOfWeek);

var _departing = require('../filters/departing/departing.filter');

var _departing2 = _interopRequireDefault(_departing);

var _formatTime = require('../filters/formatTime/formatTime.filter');

var _formatTime2 = _interopRequireDefault(_formatTime);

require('./app.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_angular2.default.module('fiapiApp', [_angularCookies2.default, _angularResource2.default, _angularSanitize2.default, _angularUiRouter2.default, _angularUiBootstrap2.default, _angularUiMask2.default, 'ui.select', 'slugifier', 'hc.marked', 'ngToast', _auth2.default, _account2.default, _admin2.default, _navbar2.default, _footer2.default, _datePicker2.default, _scheduleView2.default, _main2.default, _schedule2.default, _event2.default, _directory2.default, _freightTime2.default, _update2.default, _media2.default, _app3.default, _util2.default, _hasDay2.default, _beachShort2.default, _dayOfWeek2.default, _departing2.default, _formatTime2.default, _ngFileUpload2.default, 'fiapiApp.services']).config(_app.routeConfig).config(['markedProvider', function (markedProvider) {
  markedProvider.setOptions({
    gfm: true,
    tables: true,
    sanitize: false
  });
}]).run(function ($rootScope, $location, Auth) {
  'ngInject';

  $rootScope.$on('$stateChangeStart', function (event, next) {
    Auth.isLoggedIn(function (loggedIn) {
      if (next.authenticate && !loggedIn) {
        $location.path('/login');
      }
    });
  });
});

_angular2.default.element(document).ready(function () {
  _angular2.default.bootstrap(document, ['fiapiApp'], {
    strictDi: true
  });
});


// WEBPACK FOOTER //
// ./client/app/app.js